import React, { createContext, useContext, useState } from "react"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import { useTheme } from "@material-ui/core/styles"

const LayoutContext = createContext()

const LayoutProvider = ({ children }) => {
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up("md"))

  const [drawerOpen, setDrawerOpen] = useState(matches ? true : false)
  const switchDrawer = () => setDrawerOpen(!drawerOpen)

  return (
    <LayoutContext.Provider value={{ drawerOpen, switchDrawer }}>
      {children}
    </LayoutContext.Provider>
  )
}

const useLayoutContext = () => useContext(LayoutContext)

export { LayoutProvider, useLayoutContext }

export default LayoutContext
